import { jwtDecode } from 'jwt-decode'
import { getToken } from './auth'

export const getUserIdFromToken = () => {
    const token = getToken()
    if (!token) return null
    const { id } = jwtDecode<{ id: string }>(token)
    return id
}
